/*
 * Copyright (c) Worldline 2022.
 */

import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-image-preview-popup',
  templateUrl: './image-preview-popup.component.html'
})
export class ImagePreviewPopupComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  currentImage

  ngOnInit(): void {
  }

}
